import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const DE_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "Briscola wie du es noch nie gesehen hast: RPG, Waifu und KI.",
      ctaWeb: "Im Web Spielen",
      ctaAndroid: "Für Android herunterladen",
      version: "Version 2.3",
      badge: "✨ Neuer Dungeon-Modus"
    },
    stats: {
      downloads: "Downloads",
      downloadsValue: ["Du zählst sie nicht!", "Server Voll", "Ein Haufen!", "Über 9000", "Zu viele zum Zählen"],
      hands: "Verlorene Hände",
      handsValue: ["Zu viele...", "Skill Issue", "Lag ist schuld", "Ich weine immer noch", "Versuchs nochmal, du hast mehr Glück"],
      rating: "Bewertung",
      ratingValue: ["Meine Oma stimmt zu", "11/10 - IGN", "Besser als Pizza", "GOTY 2026", "Absolutes Meisterwerk"],
      waifus: "Waifu",
      waifusValue: ["Alle für dich", "Nur 2D > 3D", "Sammle sie alle!", "Waifu > Meta", "Der wahre Schatz"]
    },
    features: {
      title: "Viel mehr als ein Kartenspiel",
      items: [
        { id: "classic", title: "Klassisches Briscola", description: "Das Originalerlebnis, perfekt und sauber.", icon: "🃏" },
        { id: "roguelike", title: "RPG Roguelike", description: "Erklimme den Turm, erhalte Elementarkräfte und besiege die Bosse.", icon: "⚔️" },
        { id: "ai", title: "Lebendige KI", description: "Dank Google Gemini beleidigen oder loben dich die Gegner in Echtzeit.", icon: "🧠" },
        { id: "gacha", title: "Gacha System", description: "Nutze Münzen, um neue Skins und seltene Hintergründe freizuschalten.", icon: "💎" },
        { id: "dungeon", title: "Dungeon Modus", description: "Stelle dich Bossen mit verrückten Regeln. Eine Niederlage und es ist vorbei.", icon: "🏰" },
        { id: "puzzle", title: "Puzzle Modus", description: "Löse komplexe Szenarien mit spezifischen Zielen.", icon: "🧩" }
      ]
    },
    video: { title: "Gameplay Trailer" },
    waifus: {
      title: "Wähle deine Partnerin",
      subtitle: "Jeder Charakter hat eine einzigartige Persönlichkeit, Synchronisation und Spielstil.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "Die Süße", personality: "Süß und sonnig, liebt es in deiner Nähe zu sein." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "Die Analytische", personality: "Berechnend und kalt. Nur Logik." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "Die Tsundere", personality: "Wettbewerbsfähig und feurig. Hasst es zu verlieren." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "Die Königin", personality: "Die dunkle Königin der Karten." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "Die Führerin", personality: "Deine vertrauenswürdige Führerin... vielleicht." }
      ]
    },
    reviews: {
      title: "Sie sagen über uns (leider)",
      items: getCommonReviews('de')
    },
    ctaStrip: {
      title: "Bereit, das Feld zu betreten?",
      subtitle: "Schließe dich anderen Spielern an und beginne dein Abenteuer heute.",
      button: "Jetzt Spielen"
    },
    footer: { privacy: "Datenschutz", terms: "AGB", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Datenschutzerklärung von Waifu Briscola",
      lastUpdated: "Letzte Aktualisierung: 25. Mai 2024",
      intro: "Diese Datenschutzerklärung beschreibt, wie Ihre Informationen verwaltet werden, wenn Sie die Anwendung Waifu Briscola ('Dienst') nutzen.",
      sections: [
        {
          title: "Informationen, die wir sammeln",
          intro: "Um Ihre Erfahrung zu verbessern, nutzen wir Dienste von Drittanbietern, die Informationen sammeln können:",
          items: [
            "Nutzungsdaten (PostHog): Wir sammeln anonyme oder pseudonyme Analysedaten darüber, wie Sie mit dem Spiel interagieren. Dies umfasst Ereignisse wie Spielbeginn, gespielte Karten und Endergebnisse. Diese Daten helfen uns zu verstehen, wie das Spiel genutzt wird und wie wir es verbessern können. Wir sammeln keine persönlich identifizierbaren Informationen (PII) über PostHog.",
            "Interaktionen mit der KI (Google Gemini): Chat-Nachrichten, die Sie senden, und Informationen über den Spielstatus (wie Karten in Ihrer Hand und auf dem Tisch) werden an die Google Gemini API gesendet, um die Antworten und Züge der KI zu generieren. Diese Interaktionen unterliegen der Datenschutzerklärung von Google. Wir senden keine persönlichen Informationen an Google außer dem Inhalt Ihrer Spielinteraktionen.",
          ],
        },
        {
          title: "Wie wir Ihre Informationen verwenden",
          intro: "Wir verwenden die gesammelten Informationen, um:",
          items: [
            "Unseren Dienst bereitzustellen, zu betreiben und zu warten.",
            "Unseren Dienst zu verbessern, zu personalisieren und zu erweitern.",
            "Zu verstehen und zu analysieren, wie Sie unseren Dienst nutzen.",
            "Missbrauch zu verhindern und Sicherheit zu gewährleisten.",
          ],
        },
        {
          title: "Weitergabe von Informationen",
          body: "Wir geben Ihre persönlichen Informationen an niemanden weiter, außer an Drittanbieter (PostHog, Google), die für den Betrieb der Anwendung erforderlich sind, wie oben beschrieben.",
        },
        {
          title: "Datensicherheit",
          body: "Die Sicherheit Ihrer Informationen ist uns wichtig, aber denken Sie daran, dass keine Methode der Übertragung über das Internet oder Methode der elektronischen Speicherung 100% sicher ist.",
        },
        {
          title: "Änderungen an dieser Datenschutzerklärung",
          body: "Wir können unsere Datenschutzerklärung von Zeit zu Zeit aktualisieren. Wir werden Sie über Änderungen informieren, indem wir die neue Datenschutzerklärung auf dieser Seite veröffentlichen.",
        },
        {
          title: "Kontaktieren Sie uns",
          body: "Wenn Sie Fragen zu dieser Datenschutzerklärung haben, können Sie den Verantwortlichen Mauro Mazzocchetti kontaktieren.",
        },
      ],
    },
    consent: { text: "Wir verwenden Cookies und Analysen, um die Website zu verbessern. Mit der Nutzung akzeptierst du unsere", ok: "Verstanden" },
    terms: {
      title: "Allgemeine Geschäftsbedingungen von Waifu Briscola",
      lastUpdated: "Letzte Aktualisierung: 25. Mai 2024",
      contact: "Verantwortlicher: Mauro Mazzocchetti",
      intro: "Willkommen bei Waifu Briscola! Diese Bedingungen beschreiben die Regeln für die Nutzung der Anwendung Waifu Briscola ('Dienst').",
      sections: [
        {
          title: "Annahme der Bedingungen",
          body: "Durch den Zugriff auf und die Nutzung dieses Dienstes erklären Sie sich mit diesen Bedingungen einverstanden. Wenn Sie mit einem Teil der Bedingungen nicht einverstanden sind, dürfen Sie den Dienst nicht nutzen.",
        },
        {
          title: "Nutzung des Dienstes",
          body: "Sie stimmen zu, den Dienst nicht für illegale oder nicht autorisierte Zwecke zu nutzen. Sie sind verantwortlich für Ihr Verhalten und alle Inhalte, die Sie während der Nutzung des Dienstes bereitstellen, einschließlich Chat-Nachrichten.",
        },
        {
          title: "KI-generierte Inhalte",
          intro: "Der Dienst verwendet Modelle künstlicher Intelligenz (Google Gemini), um Antworten, Kommentare und Spielzüge zu generieren. Sie erkennen an, dass:",
          items: [
            "KI-generierte Inhalte von einem Modell produziert werden und nicht immer genau, angemessen oder konsistent sein können.",
            "Wir nicht für KI-generierte Inhalte verantwortlich sind.",
            "Interaktionen mit der KI nur zu Unterhaltungszwecken gedacht sind.",
          ],
        },
        {
          title: "Haftungsbeschränkung",
          body: "In keinem Fall sind Mauro Mazzocchetti oder seine Partner haftbar für indirekte, zufällige, spezielle, Folge- oder Strafschäden, einschließlich, aber nicht beschränkt auf entgangenen Gewinn, Datenverlust, Firmenwert oder andere immaterielle Verluste, die aus (i) Ihrem Zugriff auf oder Ihrer Nutzung oder Unfähigkeit zum Zugriff oder zur Nutzung des Dienstes; (ii) Inhalten, die über den Dienst erhalten wurden, resultieren.",
        },
        {
          title: "Änderungen der Bedingungen",
          body: "Wir behalten uns das Recht vor, diese Bedingungen nach eigenem Ermessen jederzeit zu ändern oder zu ersetzen. Wir werden Sie über Änderungen informieren, indem wir die neuen Bedingungen auf dieser Seite veröffentlichen.",
        },
        {
          title: "Anwendbares Recht",
          body: "Diese Bedingungen unterliegen den italienischen Gesetzen und werden in Übereinstimmung mit diesen ausgelegt, ohne Rücksicht auf deren kollisionsrechtliche Bestimmungen.",
        },
      ],
    }
};
